import { Attr, HasMany, HasOne, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type ActiveStorageAttachment from "./ActiveStorageAttachment";
import type Organisation from "./Organisation";
import type OrganisationReportSpec from "./OrganisationReportSpec";
import type Stream from "./Stream";
import type User from "./User";

@Model()
class OrganisationReportComment extends ApplicationRecord {
  static jsonapiType = "organisation_report_comments";

  @HasOne() accountManager: User;

  @Attr() accountManagerId: number;

  @HasOne() approver: User;

  @Attr() approverId: number;

  @Attr() assignedTo: string;

  @HasOne() assignee: User;

  @Attr() assigneeId: number;

  @HasMany() attachments: ActiveStorageAttachment[];

  @HasOne() author: User;

  @Attr() authorId: number;

  @Attr() category: string;

  @Attr() closed: boolean;

  @Attr({ persist: false }) createdAt: string;

  @Attr() expiresAt: string;

  @Attr() mentionId: number;

  @Attr() mentionType: string;

  @HasOne() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() parentId: number;

  @HasOne() specification: OrganisationReportSpec;

  @Attr() specificationId: number;

  @HasOne() stream: Stream;

  @Attr() streamId: number;

  @HasMany() subComments: OrganisationReportComment[];

  @Attr() text: string;

  @Attr({ persist: false }) updatedat: string;
}

export default OrganisationReportComment;
